import overArg from './_overArg.js';

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

export default getPrototype;



//////////////////
// WEBPACK FOOTER
// ../~/_lodash-es@4.17.15@lodash-es/_getPrototype.js
// module id = 1182
// module chunks = 1